import React, { InputHTMLAttributes } from 'react';
import { WrappedFieldProps } from 'redux-form';

import styles from './style.css';

interface InputFieldProps extends WrappedFieldProps {
  readonly maxLength?: InputHTMLAttributes<HTMLInputElement>['maxLength'];
}

export default function InputField(field: InputFieldProps) {
  return (
    <div>
      <input
        {...field.input}
        type="text"
        maxLength={field.maxLength}
        className={`form-control ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={'Email or phone number'}
      />
      <small className="error">
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
}
